import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useDatePickerColumn,
  BaseButton,
  useSelectColumn,
  useCreateModal
} from 'xrk-components';
import { formatter } from '@/utils';
import { INVOICE_TYPE, INVOICE_STATUS } from '@V/invoice/src/constants';
import {
  queryInvoiceList,
  listSelectEnterprise
} from '@V/invoice/src/data-source/apis';
import InvoiceDetailIndividualDialog from '../components/invoice-detail-individual-dialog';
import { useRouter, useRoute } from 'vue-router';
import InvoiceDetailDialog from '@V/invoice/src/components/invoice-detail-dialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-individua-filingl-list',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const xrkTableRef = ref();

const getListAjax = async params => {
  return queryInvoiceList({ ...params, resource: 3 });
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useSelectColumn({
      prop: 'industryId',
      label: '客户企业',
      config: {
        clearable: true,
        filterUseRemote: true,
        remoteMethod: async name => {
          const res: any = await listSelectEnterprise({
            industryName: name
          });
          return res;
        },
        labelKey: 'industryName',
        valueKey: 'industryId',
        maxlength: 50
      }
    }),
    useDatePickerColumn({
      prop: 'time',
      label: '更新时间',
      config: {
        type: 'daterange',
        startPlaceholder: '时间始',
        endPlaceholder: '时间止',
        clearable: true
      },
      listener: {
        onChange: (value, searchObj) => {
          if (!value) {
            searchObj.openAtStart = '';
            searchObj.openAtEnd = '';
          } else {
            searchObj.openAtStart = value[0];
            searchObj.openAtEnd = value[1];
          }
        }
      }
    })
  ].filter(item => item),
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      if (Object.keys(route.query).length) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              type="primary2"
              click={async () => {
                useCreateModal(
                  InvoiceDetailIndividualDialog,
                  {
                    onSuccess() {
                      xrkTableRef.value.initCurrentList();
                    }
                  },
                  getCurrentInstance()
                );
              }}
            >
              上传发票
            </BaseButton>
          </>
        );
      }
    }
  ].filter(item => item)
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '发票申请编号',
      prop: 'invoiceOrderNo',
      width: '180px'
    }),
    useTableColumn({
      label: '个体户企业名称',
      prop: 'individualName',
      width: 300
    }),
    useTableColumn({
      label: '所属园区',
      prop: 'businessParkName',
      width: '180px'
    }),
    useTableColumn({
      label: '票面金额(元)',
      prop: 'invoiceAmount',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '发票类目',
      prop: 'itemName'
    }),
    useTableColumn({
      label: '发票类型',
      prop: 'invoiceType',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(cellValue, () => INVOICE_TYPE[cellValue].label)
    }),
    useTableColumn({
      label: '开票状态',
      prop: 'invoiceStatus',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(
          cellValue,
          () => INVOICE_STATUS[cellValue].label
        )
    }),
    useTableColumn({
      label: '更新时间',
      prop: 'authAt',
      minWidth: '180px',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handlerCol',
      fixed: 'right',
      render: ({ row }) => {
        return (
          <>
            <BaseButton
              type="text"
              click={async () => {
                useCreateModal(InvoiceDetailDialog, {
                  id: row.id,
                  detailType: 1,
                  onSuccess() {
                    xrkTableRef.value.initCurrentList();
                  }
                });
              }}
            >
              详情
            </BaseButton>
          </>
        );
      }
    })
  ].filter(item => item)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XrkTable), {
    ref_key: "xrkTableRef",
    ref: xrkTableRef,
    getListAjax: getListAjax,
    searchConfig: searchConfig.value,
    tableConfig: tableConfig.value
  }, null, 8, ["searchConfig", "tableConfig"]))
}
}

})